import _u from './utility';
import _v from './vars';
import _fn from './main-fn';

const setContextData = function() {

	// Sitename
	if (typeof _v.g['s_site'] == "undefined" && typeof PageMetadata.trackSegVars != "undefined" && typeof PageMetadata.trackSegVars.site != "undefined") {
		_v.g['s_site'] = PageMetadata.trackSegVars.site;
	}
	if (typeof _v.g['s_site'] == "undefined" || _v.g['s_site'] == null || _v.g['s_site'] == "null" || _v.g['s_site'] == "") {
		_fn.wmdSetContext('wb.site', _v.main_domain_name);
	} else {
		_fn.wmdSetContext('wb.site', _v.g['s_site']);
	}
	
	// Check if VisitorAPI is Present
	if (typeof(Visitor) !== "undefined") {
		_fn.wmdSetContext('wb.vapi', 'VisitorAPI Present');
	} else {
		_fn.wmdSetContext('wb.vapi', 'VisitorAPI Missing');
	}

	// PPE-76710 - Short Title
	if (document.getElementsByTagName('head')[0].getElementsByTagName('title').length > 0) {
		_v.s_shtitle = document.getElementsByTagName('head')[0].getElementsByTagName('title')[0].innerHTML.toLowerCase();
		_v.s_shtitle = _v.s_shtitle.replace(/<[^>]+>/g,"").replace(/&\S+\;/g,'').replace(/[–_—]/g,'-').replace(/[&%\$']/g,'').replace(/\s+/g,' ').replace(/^\s+/g, '').replace(/\s+$/g,'');
		_fn.wmdSetContext('wb.pgtitle', _v.s_shtitle);
	}

	/* ICD + ECD (ported from Consumer) */
	var qicd, qecd, vendor, publisher;
	qicd = _u.readQ("ICD");
	qecd = _u.readQ("ECD");

	if (qicd === "") {
		qicd = _u.readQ("icd");
	}
	if (qecd === "") {
		qecd = _u.readQ("ecd");
	}

	if (qicd !== "") {
		_fn.wmdSetContext('wb.icd', qicd.toLowerCase());
	}

	if (qecd !== "") {
		vendor = _u.readQ("v");
		publisher = _u.readQ("p");

		if (vendor !== "") {
			vendor = vendor.split("_").join("-");
			qecd = (qecd.lastIndexOf("_") === 0) ? qecd + vendor : qecd + "_" + vendor;
		}
		if (publisher !== "") {
			publisher = publisher.split("_").join("-");
			qecd += "_" + publisher;
		}
		qecd = qecd.toLowerCase();
		qecd = qecd.split("__").join("_").split("%20").join("-");

		_fn.wmdSetContext('wb.ecd', qecd);
		_fn.pushContextClr('wb.ecd'); // clear after first pageview
	}
	/* /ICD + ECD (ported from Consumer) */
	
	// SRC Marker
	if (_u.readQ("src") !== "") {
		wmdSetContext('wb.src', _u.readQ("src").toLowerCase());
	}

	// PPE-76774 - Search Query
	if (window.location.href.indexOf('/search') == -1 && document.referrer.indexOf('/search') !== -1 && document.referrer.match(/q=[^&]+/) != null) {
		_fn.wmdSetContext('wb.querytext',decodeURIComponent(document.referrer.match(/q=[^&]+/)[0].split('=')[1].toLowerCase()));
		_fn.pushContextClr('wb.querytext');
	}
	if (window.location.href.indexOf('/search') && window.location.href.match(/q=[^&]+/) != null) {
		_fn.wmdSetContext('wb.query',decodeURIComponent(_u.readQ('q')));
	}

	// PPE-76771 - FAF/FPF
	if (typeof window.isFPFEligible !== "undefined" && window.isFPFEligible !== null) {
		_fn.wmdSetContext('wb.frpg', s_md.pageName);
	}
	
	// Error Code for 404 pages
	if (typeof window.s_error !== 'undefined' && (window.s_error == "true" || window.s_error == "t" || window.s_error == true)) {
		s_md.pageType = "errorPage";
	}
	
	// Helper function to check cookie for specific consent groups
	function hasAcceptedPerformanceCookie() {
		return document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0002%3A1/);
	}
	
	// Helper constants to check if scripts are present
	const isGdprApplicable = (document.querySelector('script[src*="otSDKStub.js"]') !== null);
	const isCpraApplicable = (document.querySelector('script[src*="otCCPAiab.js"]') !== null);
	const consentRegime = (isGdprApplicable && isCpraApplicable) ? 'CPRA' : 'GDPR';
	
	if ((isCpraApplicable && (hasAcceptedPerformanceCookie() || document.cookie.indexOf('OptanonAlertBoxClosed') === -1)) || (isGdprApplicable && hasAcceptedPerformanceCookie() && document.cookie.indexOf('OptanonAlertBoxClosed') !== -1) || (!isCpraApplicable && !isGdprApplicable)) {
		_fn.wmdSetContext('wb.gdprauth', consentRegime + '-yes');
	} else if (!hasAcceptedPerformanceCookie() && (isGdprApplicable || isCpraApplicable)) {
		_fn.wmdSetContext('wb.gdprauth', consentRegime + '-no');
	}
	
	_fn.createPageState();
	_fn.scanCtxVars();
	_fn.scanMetaDataKeys();
	/* PPE-158541 - Asset ID */
	function formatAssetId() {
		var artId = "";
		var assetId = "";
		var pagePath = "";
		if (typeof PageMetadata != 'undefined' && _fn.chkPageMetaKey('pageSegVars', 'art')) {
			artId = "'" + PageMetadata.pageSegVars.art.toString().replace(/^(ckb|drg)/,'') + "'";
		}
		if (typeof PageMetadata != 'undefined' && _fn.chkPageMetaKey('pageSegVars', 'asst')) {
			assetId = "'" + PageMetadata.pageSegVars.asst + "'";
		}
		if (window.location.pathname != '/') {
			pagePath = "'" + window.location.pathname + "'";
		}
		_fn.wmdSetContext('wb.asset', '[' + artId + '], [' + assetId + '], [' + pagePath + ']');
	}
	formatAssetId();
	/* /PPE-158541 - Asset ID */

	//PPE-197865 - add percent of page viewed
	//function to store and send getPercentPageViewed data to omniture
	function percentPageViewed() {
		//call function from getPercentPageViewed Adobe plugin
		try {
			getPercentPageViewed();
		} catch(e) { }
		if (typeof window._ppvHighestPercentViewed !== 'undefined') {
			_fn.wmdSetContext('wb.pctvw', window._ppvHighestPercentViewed);
		}
	}
	//scroll event for getPercentPageViewed - debounce every 150 ms
	var percentTimer;
	window.addEventListener('scroll', function() {
		clearTimeout(percentTimer);
		percentTimer = setTimeout(percentPageViewed, 150);
	}, false);

}

export default setContextData;
